import { GetCarSpecifications_carSpecifications } from '../../gqlCustomise/graphql/queries/__generated__/GetCarSpecifications';
import { ISpecGroups } from '../model/ISpecfications';

const specDataExtractor = {
  getSpecPackByGroup: (data: GetCarSpecifications_carSpecifications[], filter: string) => {
    const specData = data.reduce((acc: ISpecGroups[], current: GetCarSpecifications_carSpecifications) => {
      if (current.groupName.includes(filter)) {
        acc = [...acc, current];
      }

      return acc;
    }, []);

    if (!specData.length) return;

    return specDataExtractor.getSpecPackArrange(specData);
  },

  getSpecPackArrange: (data: ISpecGroups[]) => {
    return data.sort((a, b) => a.displayOrder - b.displayOrder);
  },
};

export default specDataExtractor;
